module.exports = __webpack_public_path__ + "img/logo.132c0aa3.png";